import { now } from '../../utils/date-service'

export const ListingViewType = {
  Grid: 1,
  List: 2,
}

export const defaultPriceRange = {
  start: '100',
  end: '250000',
}

export const defaultLeaseFinanceRange = {
  start: '0',
  end: '3000',
}

export const defaultYearRange = {
  start: '0',
  end: `${now().getFullYear() + 1}`,
}

export const defaultMileageRange = {
  start: '0',
  end: '200000',
}

export const defaultMaxMileageValue = 200_000

export const defaultLocation = {
  zipCode: '',
  latitude: null,
  longitude: null,
}

export const defaultDistance = 250

export const defaultPageSize = 12
